import axios from "axios";
import cookie from "react-cookies";
import { store, persistor } from "store/index";
import { setToken, setLoader, setSub, setPasswordPopup } from "action/index.js";
store.subscribe(listener);

let base = process.env.REACT_APP_API_URL;

// const base = `https://ladevtesting.languageacademy.com.au`;
// const s3base = `https://testing.languageacademy.com.au`;
// const s3base = `http://127.0.0.1:8000`;
const s3base = "https://s3.ap-southeast-2.amazonaws.com/lamedia21";
console.log(base,"baseurl>>>>>>>>>>>>>>>>");
const axiosInstance = axios.create({
  baseURL: `${base}/api/v2`,
  // withCredentials: true
});

axiosInstance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axiosInstance.defaults.headers.common["Cache-Control"] = "no-store";
axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

function select(state) {
  return state.token;
}
function listener() {
  let token = select(store.getState());
  axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

const errorHandler = (error) => {
  if (error?.config?.url !== "https://la-ping.languageacademy.com.au/connected") {
    if (
      error?.response?.status === 503 &&
      error?.response?.data?.status === "server is down for maintenance"
    ) {
      window.location.href = "/maintenance";
    }

    if (isHandlerEnabled(error?.config)) {
      // Handle errors
    }
    store.dispatch(setLoader(true));
    console.error(error);

    // if (error !== undefined && error.response !== undefined) {
    if (error?.response?.status === 401) {
      store.dispatch(setToken(null));
      store.dispatch(setPasswordPopup(false));
    }
    if (error?.response?.status === 402) {
      store.dispatch(setSub(false));
    }
    // }
    store.dispatch(setLoader(true));
  }
  // return error;
  return Promise.reject(error);
};

const isHandlerEnabled = (config = {}) => {
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

const requestHandler = (request) => {
  // Skip region access check for full URLs (external APIs)
  if (request.url && request.url.startsWith("http")) {
    // Only handle loader for external URLs
    if (request.url !== "https://la-ping.languageacademy.com.au/connected") {
      store.dispatch(setLoader(false));
    }
    return request;
  }
  // Region access check
  const state = store.getState();
  const { token, regionAccess } = state;

  if (token && !regionAccess) {
    const allowedEndpoints = [
      "logout",
      "getPackages",
      "getCcavPackages",
      "subscribe",
      "getNotifications",
      "/sub/payment/form/32",
      "/sub/success",
      "voidInvoice",
      "https://ipbackend22.languageacademy.com.au/api/v2/getPackages?countryId=",
    ];
    const authEndpoints = ["login", "register", "forgot", "reset"];
    const planEndpoints = ["plan", "payment", "sub", "ccav"];

    // Check if URL matches any allowed endpoint (including query params)
    const isAllowedEndpoint = allowedEndpoints.some(
      (endpoint) =>
        request.url === endpoint || request.url.startsWith(endpoint + "?")
    );

    const isAuthEndpoint = authEndpoints.some((endpoint) =>
      request.url.includes(endpoint)
    );

    const isPlanEndpoint = planEndpoints.some((endpoint) =>
      request.url.includes(endpoint)
    );

    const isAllowed = isAllowedEndpoint || isAuthEndpoint || isPlanEndpoint;

    if (!isAllowed) {
      return Promise.reject({
        response: {
          status: 403,
          data: { message: "Region access restricted" },
        },
      });
    }
  }

  if (
    request.url !== "check/payment" &&
    request.url !== "delete/question/responseNew" &&
    !/^submit\/practice\?random=\d{1,9}$/.test(request.url) &&
    request.url !== "show/history" &&
    request.url !== "show/comment" &&
    request.url !== "show/notes" &&
    request.url !== "submit/mock" &&
    request.url !== "set/mockTime" &&
    request.url !== "set/tag" &&
    request.url !== "dashboard/data2" &&
    request.url !== "https://la-ping.languageacademy.com.au/connected" &&
    request.url !== "submitFailed/mock" &&
    request.url !== "translate/sentence" &&
    request.url !== "generate/aiaudio" &&
    request.url !== "word/definition" &&
    request.url !== "submit-explanation" &&
    request.url !== "get-explanation"
  ) {
    store.dispatch(setLoader(false));
  }

  return request;
};

axiosInstance.interceptors.request.use((request) => requestHandler(request));

const successHandler = (response) => {
  if (isHandlerEnabled(response.config)) {
    // Handle responses
  }
  store.dispatch(setLoader(true));
  // console.log(store.getState().token);
  return response;
};

export const directApiCall = async (config) => {
  console.log("direct api call");
  // Create a new axios instance without baseURL for full URLs
  const directAxios = axios.create();

  // Copy all the same configurations from the main instance
  directAxios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  directAxios.defaults.headers.common["Cache-Control"] = "no-store";

  // Add authentication token
  const token = select(store.getState());
  console.log(token);
  if (token) {
    console.log("Here is the token ",token);
    directAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  // Add the same interceptors
  directAxios.interceptors.response.use(
    (response) => successHandler(response),
    (error) => errorHandler(error)
  );

  // directAxios.interceptors.request.use((request) => requestHandler(request));

  return await directAxios(config);
};

export default axiosInstance;
export { base, s3base };
